import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography, useTheme } from "@mui/material";
import { FunctionComponent, ReactNode } from "react";
import { InfoRounded, WarningRounded } from "@mui/icons-material";
import { Stack } from "@mui/system";
import { useTranslation } from "react-i18next";

interface ExpiredCustomDialogProps {
    open: boolean,
    onClose?: () => void,
    title?: string,
    contentDescription: ReactNode,
    buttonCloseDescription?: string,
    buttonConfirmDescription?: string,
    onConfirm?: () => void,
    
}

const ExpiredCustomDialog: FunctionComponent<ExpiredCustomDialogProps> = ({
    open,
    onClose,
    title,
    contentDescription,
    buttonCloseDescription,
    buttonConfirmDescription,
    onConfirm
}) => {

    const theme = useTheme();
    const { t } = useTranslation(["expiredManagement"]);

    return (
        <Dialog open={open} onClose={() => { return; }} >
            {!!title && 
                <DialogTitle>
                    <Box sx={{display: "flex", alignItems: "center"}}>
                        <Typography color={"primary"} fontWeight={"bold"} sx={{paddingLeft: 1}}>
                            {title}
                        </Typography>
                    </Box>
                </DialogTitle>
            }
            <DialogContent >
                <Box sx={{padding: theme.spacing(2), display: "flex", alignItems: "center", justifyContent: "center"}} > 
                    {contentDescription}
                </Box> 
            </DialogContent>
            <DialogActions sx={{backgroundColor: theme.palette.neutral.bright, padding: theme.spacing(2)}}>
                <Stack direction="row" columnGap={1}>
                    {buttonCloseDescription && 
                        <Button 
                            variant="outlined"
                            disableElevation
                            color="accent"
                            sx={{backgroundColor: theme.palette.neutral.bright}}
                            onClick={onClose}
                        >
                            <Typography fontWeight={"bold"} variant="subtitle2" color="accent" lineHeight={0}>
                                {buttonCloseDescription}
                            </Typography>
                        </Button>
                    }
                    {buttonConfirmDescription && 
                        <Button 
                            color="accent"
                            variant="contained"
                            disableElevation
                            onClick={onConfirm}
                        >
                            <Typography fontWeight={"bold"} variant="subtitle2" color="accent" lineHeight={0}>
                                {buttonConfirmDescription}
                            </Typography>
                        </Button>
                    }                    
                </Stack>
            </DialogActions>
        </Dialog>
    );

}

export default ExpiredCustomDialog;